<template>
  <div class="ui-columns-config-item">
    <Bars3Icon aria-hidden="true" class="ui-columns-config-item__handle handle" />
    <UICheckbox v-model="modelValue" :label />
  </div>
</template>

<script lang="ts" setup>
import { Bars3Icon } from '@heroicons/vue/24/outline'
import { UICheckbox } from '@ui/controllers'

type Props = {
  label: string
}

defineProps<Props>()

const modelValue = defineModel<boolean>({ default: false })

</script>

<style scoped>
.ui-columns-config-item {
  @apply flex items-center;
  @apply gap-2;
  @apply text-light-text;

  &__handle {
    @apply w-4 h-4 cursor-move;
  }
}
</style>
